module.exports = __webpack_public_path__ + "static/media/TH6.b54f5b7d.jpg";